<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64" width="100%">
        <v-toolbar flat>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="#FFD02F"
            class="ml-5 boton"
            @click="link('https://miro.com/')"
          >
          </v-btn>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="78vh" width="100%">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="#f68b23"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="300px">
            <v-toolbar color="#06163a" dark>
              <v-icon x-large>mdi-calendar-today</v-icon>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon @click="selectedOpen = false">mdi-close</v-icon>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions v-if="selectedEvent.state === 'enable'">
              <v-btn
                text
                color="secondary"
                @click="cancelEvent(selectedEvent.start)"
              >
                Cancel Meeting
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#f68b23"
                class="white--text"
                @click="link('https://meet.google.com/fop-czay-rvo')"
              >
                Link
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { GetFormatDateType1 } from "../util/dateFunction.js";
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    consultant: {
      type: String,
      default: "Jose Luis",
    },
  },
  data: () => ({
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: ["#9dcdfb"],
    names: ["Meeting"],
  }),
  computed: {
    ...mapGetters("CalendarEvents", ["getEvents"]),
  },
  methods: {
    ...mapMutations("CalendarEvents", ["mtaRemoveEvent"]),
    startTour() {
      this.$tours["CalendarSteps"].start();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange() {
      const events = [];

      this.getEvents.forEach((element) => {
        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: element.start,
          end: element.end,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: false,
          details: `
          <strong>Phase:</strong>${element.phase}<br>
          <strong>Process:</strong>${element.process}<br>
          <strong>When:</strong>${GetFormatDateType1(
            element.start
          )} ${element.start.getHours()}:${element.start.getMinutes()} - ${element.end.getHours()}:${element.end.getMinutes()}
          <br>
          <strong>With:</strong> ${element.consultant}
          `,
          state: element.start < new Date() ? "disable" : "enable",
        });
      });

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    cancelEvent(value) {
      console.log(value);
      this.mtaRemoveEvent(value);
      this.selectedOpen = false;
      this.updateRange();
    },
    link(link) {
      this.selectedOpen = false;
      window.open(link);
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
};
</script>
<style scoped>
.boton {
  background-image: url("../assets/miro.jpeg");
  background-position: center; /* Center the image */
  background-size: contain;
}
</style>
